export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11392.a2a94d8e.jpg";